// @ts-nocheck
import React, { useState } from 'react';
import { HStack, Heading, Box, Button } from '@chakra-ui/react';
import ScoreBoard from './ScoreBoard';
import HighScore from './highScore'; // Ensure correct capitalization of file
import Points from './Points'; // Ensure this is the correct file path
import TotalScore from './totalScore'; // Ensure correct capitalization of file

const ScoreSection = ({ scoreDisplay, score }) => {
  const [resetKey, setResetKey] = useState(0);

  const handleReset = () => {
    // Trigger a re-render of TotalScore by updating resetKey
    setResetKey(prevKey => prevKey + 1);
    // Reset the total score in local storage
    localStorage.setItem('totalScore', '0');
  };

  return (
    <Box width="100%" display="flex" flexDirection="column" alignItems="center" mt={0}>
      <HStack width="90%" justifyContent="space-between"  flexDirection="row" spacing={2}>
        <Box>
          <Heading as="h5" size="xs" color="blue.500"></Heading>
          <HighScore score={scoreDisplay} />
        </Box>
        <Box>
          <Heading as="h5" size="xs" color="blue.500"></Heading>
          <ScoreBoard score={scoreDisplay} />
        </Box>
        <Box>
          <Heading as="h5" size="xs" color="blue.500"></Heading>
          <TotalScore scoreDisplay={scoreDisplay} />
        </Box>
        
       
      </HStack>
      
    </Box>
  );
};

export default ScoreSection;
